import React, { useContext } from 'react'
import { ReactFinalFormContext } from 'react-final-form'
import { trackOnBlur as trackSignUpModal } from 'tracking/form'
import { trackOnBlur as trackLoginModal } from 'tracking/loginEvents'
import { OnBlur } from 'react-final-form-listeners'

const FieldTracking = props => {
  const { getFieldState } = useContext(ReactFinalFormContext)

  const getFieldvalue = () => {
    const value = getFieldState(props.name).value || ''
    switch (props.name) {
      case 'password1':
      case 'password':
        const passwordValue = Array(value.length).join('*')
        return { fieldValue: passwordValue, fieldName: props.name }
      case 'email':
        const emailName = props.modal === 'login' ? 'emailOrMobile' : 'email'
        return { fieldValue: value, fieldName: emailName }
      default:
        return { fieldValue: value, fieldName: props.name }
    }
  }

  return (
    <OnBlur name={props.name}>
      {() => {
        const { fieldName, fieldValue } = getFieldvalue()
        const payload = { fieldValue, fieldName }
        return props.modal === 'login'
          ? trackLoginModal(payload)
          : trackSignUpModal(payload)
      }}
    </OnBlur>
  )
}

export default FieldTracking
